import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, vModelSelect as _vModelSelect, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full md:px-6 py-6" }
const _hoisted_3 = { class: "bg-white rounded-xl shadow-lg border border-gray-200 p-4 md:p-6" }
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-8" }
const _hoisted_5 = { class: "flex flex-col h-full" }
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "beu-upload-row flex flex-wrap items-center gap-3" }
const _hoisted_10 = { class: "flex flex-col min-w-0" }
const _hoisted_11 = { class: "text-sm text-black truncate max-w-[200px]" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "beu-upload-row flex flex-wrap items-center gap-3" }
const _hoisted_17 = { class: "flex flex-col min-w-0" }
const _hoisted_18 = { class: "text-sm text-black truncate max-w-[200px]" }
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "mt-auto pt-6 flex justify-end" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "flex flex-col h-full" }
const _hoisted_26 = { class: "space-y-6" }
const _hoisted_27 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_30 = {
  key: 1,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_31 = {
  key: 2,
  class: "text-xs text-green-600 mt-1 flex items-center"
}
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = {
  key: 0,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_34 = {
  key: 1,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_35 = {
  key: 2,
  class: "text-xs text-green-600 mt-1 flex items-center"
}
const _hoisted_36 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_37 = { class: "flex flex-col min-w-0" }
const _hoisted_38 = { class: "text-sm text-black truncate max-w-[200px]" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = ["href"]
const _hoisted_41 = ["src"]
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_44 = { class: "flex flex-col min-w-0" }
const _hoisted_45 = { class: "text-sm text-black truncate max-w-[200px]" }
const _hoisted_46 = { class: "flex items-center gap-2" }
const _hoisted_47 = ["href"]
const _hoisted_48 = ["src"]
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "space-y-4" }
const _hoisted_51 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_52 = { class: "flex flex-col min-w-0" }
const _hoisted_53 = { class: "text-sm text-black truncate max-w-[200px]" }
const _hoisted_54 = { class: "flex items-center gap-2" }
const _hoisted_55 = ["href"]
const _hoisted_56 = ["src"]
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "mt-auto pt-6 flex justify-end" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "bg-white rounded-xl shadow-lg border border-gray-200 p-6" }
const _hoisted_61 = { class: "flex items-center justify-between mb-6" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "text-md font-medium text-black" }
const _hoisted_64 = { class: "px-6 pb-6 pt-2 space-y-4" }
const _hoisted_65 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = { class: "relative" }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = { class: "relative" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "relative" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = { class: "relative" }
const _hoisted_75 = ["onUpdate:modelValue", "onInput"]
const _hoisted_76 = {
  key: 0,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_77 = {
  key: 1,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_78 = {
  key: 2,
  class: "text-xs text-green-600 mt-1 flex items-center"
}
const _hoisted_79 = { class: "relative" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = { class: "relative" }
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = ["value"]
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = ["value"]
const _hoisted_89 = ["onUpdate:modelValue", "onInput"]
const _hoisted_90 = {
  key: 0,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_91 = {
  key: 1,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_92 = {
  key: 2,
  class: "text-xs text-red-500 mt-1 flex items-center"
}
const _hoisted_93 = {
  key: 3,
  class: "text-xs text-green-600 mt-1 flex items-center"
}
const _hoisted_94 = { class: "md:col-span-2" }
const _hoisted_95 = { class: "space-y-3" }
const _hoisted_96 = { class: "beu-upload-row flex items-center gap-3" }
const _hoisted_97 = ["onChange"]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "text-sm text-black" }
const _hoisted_100 = { class: "flex items-center gap-2" }
const _hoisted_101 = ["href"]
const _hoisted_102 = ["src"]
const _hoisted_103 = ["href"]
const _hoisted_104 = { class: "beu-upload-row flex items-center gap-3" }
const _hoisted_105 = ["onChange"]
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { class: "text-sm text-black" }
const _hoisted_108 = { class: "flex items-center gap-2" }
const _hoisted_109 = ["href"]
const _hoisted_110 = ["src"]
const _hoisted_111 = ["href"]
const _hoisted_112 = { class: "beu-action-buttons mt-4 flex justify-end" }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = ["onClick"]
const _hoisted_115 = { class: "bg-gray-50 p-6 rounded-xl border border-gray-200" }
const _hoisted_116 = { class: "space-y-4" }
const _hoisted_117 = { class: "flex items-center gap-3" }
const _hoisted_118 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_119 = ["disabled"]
const _hoisted_120 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_121 = { class: "rounded-lg border border-blue-200 bg-blue-50 p-4 space-y-3" }
const _hoisted_122 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 text-sm"
}
const _hoisted_125 = { class: "rounded-md bg-white border border-blue-100 p-3" }
const _hoisted_126 = {
  key: 0,
  class: "block text-xs text-gray-500"
}
const _hoisted_127 = { class: "rounded-md bg-white border border-blue-100 p-3" }
const _hoisted_128 = { class: "rounded-md bg-white border border-blue-100 p-3" }
const _hoisted_129 = { class: "rounded-md bg-white border border-blue-100 p-3" }
const _hoisted_130 = { class: "flex flex-wrap justify-center gap-3" }
const _hoisted_131 = ["disabled"]
const _hoisted_132 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_133 = ["disabled"]
const _hoisted_134 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_135 = ["disabled"]
const _hoisted_136 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_137 = ["disabled"]
const _hoisted_138 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_139 = ["disabled"]
const _hoisted_140 = ["disabled"]
const _hoisted_141 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_142 = ["disabled"]
const _hoisted_143 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_144 = ["disabled"]
const _hoisted_145 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_146 = {
  key: 0,
  class: "rounded-lg border border-gray-300 bg-gray-950 p-4 text-left"
}
const _hoisted_147 = { class: "flex flex-wrap items-center justify-between gap-2 mb-3 text-xs text-gray-300" }
const _hoisted_148 = { class: "max-h-96 overflow-auto whitespace-pre-wrap break-words text-xs text-green-300" }

import { ref, reactive, onMounted,watch,computed } from 'vue'
import { PageHeader, ModalComp } from '@/components'
import { useNotification } from '@/composables/useNotification'
import type { BankFormData, BeneficiaryInfo } from '@/types'
import { getVendeurHipayBeu, saveVendeurHipayBeu,deleteVendeurHipayBeneficiary,saveVendeurHipayBeneficiary, getHipayFiles, submitVendeurHipayAccount, deleteVendeurHipayUboStatement, type HipaySubmitStep } from '@/api/vendeur'
import { uploadHipayFile } from '@/api/vendeur'
import {useRouter} from "vue-router";
import {useAuthStore} from "@/stores/auth";
import { fetchAdminHipayUboStatement, refreshAdminHipayVendor, type AdminHipayUboStatementResult, type AdminHipayVendor } from '@/api/adminHipay'


const MAX_BENEFICIARIES = 4

// Refs pour les inputs de fichiers
type BeuActionStep = HipaySubmitStep
type PreviewEntry = { url: string; isImage: boolean }

type ExistingFiles = {
  manager: { identityFrontUrl?: string; identityBackUrl?: string }
  company: { ribUrl?: string; kbisUrl?: string; signedArticlesUrl?: string }
  beneficiaries: Record<number, { frontUrl?: string; backUrl?: string }>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BeuInfoView',
  setup(__props) {

const countryOptions = [
  { code: 'CN', label: 'Chine' },
  { code: 'FR', label: 'France' },
  { code: 'US', label: 'États-Unis' },
  { code: 'DE', label: 'Allemagne' },
]

const nationalityOptions = [
  { code: 'CN', label: 'Chinois' },
  { code: 'FR', label: 'Français' },
  { code: 'US', label: 'Américain' },
  { code: 'DE', label: 'Allemand' },
]

// État réactif
const formData = reactive<BankFormData>({
  manager: {
    lastName: '',
    firstName: '',
    identityCard: null,
    identityCardBack: null
  },
  company: {
    vatNumber: '',
    iban: '',
    companyRib: null,
    kbisDocument: null,
    signedArticles: null
  },
  beneficiaries: [
    {
      id: 1,
      salutation: 'Monsieur',
      lastName: '',
      firstName: '',
      identityCardNumber: '',
      address: '',
      postalCode: '',
      city: '',
      functionInCompany: 'CEO',
      birthDate: '',
      birthCity: '',
      birthCountry: 'Chine',
      nationality: 'Chinois',
      sharePercentage: '',
      identityCard: null,
      identityCardBack: null
    }
  ],
  consentAccepted: false
})

let nextBeneficiaryId = 2
const identityCardInput = ref<HTMLInputElement>()
const identityCardBackInput = ref<HTMLInputElement>()
const companyRibInput = ref<HTMLInputElement>()
const kbisInput = ref<HTMLInputElement>()
const signedArticlesInput = ref<HTMLInputElement>()

const showDeleteModal = ref(false)
const beneficiaryToDelete = ref<number | null>(null)
const showSaveBeneficiaryModal = ref(false)
const showSaveFormModal = ref(false)
const showDeleteUboStatementModal = ref(false)
const isSavingForm = ref(false)
const isSavingManager = ref(false)
const isSavingCompany = ref(false)
const beneficiaryToSave = ref<any | null>(null)
const pendingFormStep = ref<BeuActionStep>('all')
const hipayBusyStep = ref<BeuActionStep | null>(null)
const isDeletingUboStatement = ref(false)
const uboRecreateRequired = ref(false)
const isRefreshingHipayStatus = ref(false)
const hipayVendorStatus = ref<AdminHipayVendor | null>(null)
const isLoadingUboStatement = ref(false)
const rawUboStatement = ref<AdminHipayUboStatementResult | null>(null)
const isBusy = computed(() => isSavingForm.value || !!hipayBusyStep.value || isDeletingUboStatement.value)
const { success, error: notifyError } = useNotification()

const router = useRouter()
const authStore = useAuthStore()
const isAdminHipayTools = computed(() => authStore.isImpersonating)

const refreshCurrentHipayStatus = async () => {
  const idVendeur = Number(authStore.user?.id_vendeur ?? authStore.user?.id)
  if (!idVendeur || isRefreshingHipayStatus.value) return
  isRefreshingHipayStatus.value = true
  try {
    hipayVendorStatus.value = await refreshAdminHipayVendor(idVendeur)
    success(
      hipayVendorStatus.value.accountId
        ? 'Statuts HiPay actualisés pour ce vendeur.'
        : `Aucun compte HiPay trouvé pour ${hipayVendorStatus.value.email || 'cet e-mail'}.`,
    )
  } catch (e) {
    notifyError(e instanceof Error ? e.message : 'Impossible d’actualiser les statuts HiPay.')
  } finally {
    isRefreshingHipayStatus.value = false
  }
}

const loadRawUboStatement = async () => {
  const idVendeur = Number(authStore.user?.id_vendeur ?? authStore.user?.id)
  if (!idVendeur || isLoadingUboStatement.value) return
  isLoadingUboStatement.value = true
  try {
    rawUboStatement.value = await fetchAdminHipayUboStatement(idVendeur)
  } catch (e) {
    rawUboStatement.value = null
    notifyError(e instanceof Error ? e.message : 'Impossible de lire le GET UBO HiPay.')
  } finally {
    isLoadingUboStatement.value = false
  }
}

const saveFormModalTitle = computed(() => {
  switch (pendingFormStep.value) {
    case 'account': return 'Envoyer les informations du compte'
    case 'documents': return 'Envoyer les documents KYC'
    case 'bank': return 'Envoyer le RIB'
    case 'ubo': return 'Envoyer les UBO'
    case 'ubo_recreate': return 'Confirmer la recréation de la déclaration UBO'
    default: return 'Demander la validation HiPay'
  }
})
const saveFormModalContent = computed(() => {
  switch (pendingFormStep.value) {
    case 'account':
      return 'Enregistrer puis mettre à jour le compte marchand HiPay (PATCH /user-account), ou le créer s’il n’existe pas ?'
    case 'documents':
      return 'Enregistrer puis envoyer les documents KYC à HiPay (POST /identification) ?'
    case 'bank':
      return 'Enregistrer puis envoyer IBAN + RIB à HiPay (POST /user-account/bank-info) ?'
    case 'ubo':
      return 'Enregistrer puis envoyer les bénéficiaires à HiPay (POST /ubo/ubo-statement puis POST /ubo) ?'
    case 'ubo_recreate':
      return 'HiPay ne retrouve aucune déclaration alors que notre historique indique un ancien envoi. Confirmez-vous la création d’une nouvelle déclaration UBO et le renvoi des bénéficiaires ? Cette action peut créer des doublons si le mauvais compte HiPay est consulté.'
    default:
      return 'Enregistrer les informations puis les envoyer à HiPay pour validation ?'
  }
})
const saveFormModalConfirm = computed(() => {
  switch (pendingFormStep.value) {
    case 'account': return 'Envoyer le compte'
    case 'documents': return 'Envoyer documents'
    case 'bank': return 'Envoyer RIB'
    case 'ubo': return 'Envoyer UBO'
    case 'ubo_recreate': return 'Confirmer et recréer'
    default: return 'Envoyer à HiPay'
  }
})


// ------- File preview helpers -------
const isImageFile = (file: File | null | undefined) => {
  if (!file) return false
  return file.type.startsWith('image/')
}

const makePreview = (file: File): PreviewEntry => ({
  url: URL.createObjectURL(file),
  isImage: isImageFile(file),
})

const revokePreview = (entry?: PreviewEntry) => {
  try { if (entry?.url) URL.revokeObjectURL(entry.url) } catch (e) { /* ignore revoke errors */ }
}

const managerPreviews = reactive<{ identityCard?: PreviewEntry; identityCardBack?: PreviewEntry }>({})
const companyPreviews = reactive<{ companyRib?: PreviewEntry; kbisDocument?: PreviewEntry; signedArticles?: PreviewEntry }>({})
const beneficiaryPreviews = reactive<Record<number, { front?: PreviewEntry; back?: PreviewEntry }>>({})

// ------- Server existing files (for echo after refresh) -------
const existingFiles = reactive<ExistingFiles>({
  manager: {},
  company: {},
  beneficiaries: {}
})

const fileNameFromUrl = (url?: string) => {
  if (!url) return ''
  const parts = url.split(/[/\\]/)
  return parts[parts.length - 1] || url
}


const deleteModalContent = computed(() => {
  if (beneficiaryToDelete.value === null) return ''
  const b = formData.beneficiaries.find(x => x.id === beneficiaryToDelete.value)
  const name = b ? `${b.lastName || ''} ${b.firstName || ''}`.trim() : ''
  return name
      ? `Êtes-vous sûr de vouloir supprimer le bénéficiaire "${name}" du formulaire ?`
      : 'Êtes-vous sûr de vouloir supprimer ce bénéficiaire du formulaire ?'
})

const saveBeneficiaryContent = computed(() => {
  if (!beneficiaryToSave.value) return ''
  const b = beneficiaryToSave.value
  const name = `${b.lastName || ''} ${b.firstName || ''}`.trim() || 'ce bénéficiaire'
  return `Enregistrer les informations pour "${name}" ?`
})
const loadHipayBeu = async () => {
  try {
    const data = await getVendeurHipayBeu()
    if (!data) return

    // manager
    formData.manager.lastName = data.manager?.lastName || ''
    formData.manager.firstName = data.manager?.firstName || ''

    // company
    formData.company.vatNumber = data.company?.vatNumber || ''
    formData.company.iban = data.company?.iban || ''

    // beneficiaries
    if (Array.isArray(data.beneficiaries) && data.beneficiaries.length > 0) {
      formData.beneficiaries = data.beneficiaries.map((b: any, idx: number) => ({
        id: b.id,
        salutation: b.salutation || 'Monsieur',
        lastName: b.lastName || '',
        firstName: b.firstName || '',
        identityCardNumber: b.identityCardNumber || '',
        address: b.address || '',
        postalCode: b.postalCode || '',
        city: b.city || '',
        functionInCompany: b.functionInCompany || 'Autre',
        birthDate: b.birthDate || '',
        birthCity: b.birthCity || '',
        birthCountry: b.birthCountry || 'CN',
        nationality: b.nationality || 'CN',
        sharePercentage: b.sharePercentage || '',
        identityCard: null,
        identityCardBack: null,
        isOpen: idx === 0,
      }))
      nextBeneficiaryId = Math.max(
          ...formData.beneficiaries.map(b => Number(b.id) || 0)
      ) + 1
    }
  }catch (e) {
    // Erreur silencieuse lors du chargement des données BEU
  }
}

// Fonction pour déclencher les inputs de fichiers
const triggerFileInput = (inputName: string) => {
  switch (inputName) {
    case 'identityCardInput':
      identityCardInput.value?.click()
      break
    case 'identityCardBackInput':
      identityCardBackInput.value?.click()
      break
    case 'companyRibInput':
      companyRibInput.value?.click()
      break
    case 'kbisInput':
      kbisInput.value?.click()
      break
    case 'signedArticlesInput':
      signedArticlesInput.value?.click()
      break
  }
}

// Fonction pour déclencher les inputs de fichiers des bénéficiaires
const triggerBeneficiaryFileInput = (beneficiaryId: number) => {
  // Pour simplifier, on utilise un input caché global
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.jpg,.jpeg,.gif,.png,.pdf'
  input.onchange = (event) => {
    const target = event.target as HTMLInputElement
    if (target.files && target.files[0]) {
      const file = target.files[0]
      const beneficiary = formData.beneficiaries.find(
          b => Number(b.id) === Number(beneficiaryId)
      )
      if (beneficiary) {
        beneficiary.identityCard = file
        // previews
        if (!beneficiaryPreviews[beneficiaryId]) beneficiaryPreviews[beneficiaryId] = {}
        revokePreview(beneficiaryPreviews[beneficiaryId].front)
        beneficiaryPreviews[beneficiaryId].front = makePreview(file)
      }
    }
  }
  input.click()
}

const triggerBeneficiaryBackFileInput = (beneficiaryId: number) => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.jpg,.jpeg,.gif,.png,.pdf'
  input.onchange = (event) => {
    const target = event.target as HTMLInputElement
    if (target.files && target.files[0]) {
      const file = target.files[0]
      const beneficiary = formData.beneficiaries.find(b => b.id === beneficiaryId)
      if (beneficiary) {
        beneficiary.identityCardBack = file
        if (!beneficiaryPreviews[beneficiaryId]) beneficiaryPreviews[beneficiaryId] = {}
        revokePreview(beneficiaryPreviews[beneficiaryId].back)
        beneficiaryPreviews[beneficiaryId].back = makePreview(file)
      }
    }
  }
  input.click()
}

// Fonctions pour gérer les uploads de fichiers
const handleIdentityCardUpload = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    formData.manager.identityCard = target.files[0]
    revokePreview(managerPreviews.identityCard)
    managerPreviews.identityCard = makePreview(target.files[0])
  }
}

const handleIdentityCardBackUpload = (event: Event) => {
  // Logique pour ajouter le verso
  //console.log('Ajouter verso de la carte d\'identité du gérant')
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    formData.manager.identityCardBack = target.files[0]
    revokePreview(managerPreviews.identityCardBack)
    managerPreviews.identityCardBack = makePreview(target.files[0])
  }
}

const handleCompanyRibUpload = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    formData.company.companyRib = target.files[0]
    revokePreview(companyPreviews.companyRib)
    companyPreviews.companyRib = makePreview(target.files[0])
  }
}

const handleKbisUpload = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    formData.company.kbisDocument = target.files[0]
    revokePreview(companyPreviews.kbisDocument)
    companyPreviews.kbisDocument = makePreview(target.files[0])
  }
}

const handleSignedArticlesUpload = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    formData.company.signedArticles = target.files[0]
    revokePreview(companyPreviews.signedArticles)
    companyPreviews.signedArticles = makePreview(target.files[0])
  }
}

const handleBeneficiaryIdentityCardUpload = (event: Event, beneficiaryId: number) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    const beneficiary = formData.beneficiaries.find(
        b => Number(b.id) === Number(beneficiaryId)
    )
    if (beneficiary) {
      beneficiary.identityCard = target.files[0]
      if (!beneficiaryPreviews[beneficiaryId]) beneficiaryPreviews[beneficiaryId] = {}
      revokePreview(beneficiaryPreviews[beneficiaryId].front)
      beneficiaryPreviews[beneficiaryId].front = makePreview(target.files[0])
    }
  }
}

const handleBeneficiaryIdentityCardBackUpload = (event: Event, beneficiaryId: number) => {
  const target = event.target as HTMLInputElement

  if (target.files && target.files[0]) {
    const file = target.files[0]

    const beneficiary = formData.beneficiaries.find(
        (b) => b.id === beneficiaryId
    )
    if (beneficiary) {

      beneficiary.identityCardBack = file
      if (!beneficiaryPreviews[beneficiaryId]) beneficiaryPreviews[beneficiaryId] = {}
      revokePreview(beneficiaryPreviews[beneficiaryId].back)
      beneficiaryPreviews[beneficiaryId].back = makePreview(file)
    }
  }
}

const handleShareInput = (event: Event, beneficiary: any) => {
  const target = event.target as HTMLInputElement
  const clean = target.value.replace(/[^\d.,]/g, '')
  beneficiary.sharePercentage = clean
}
// Fonctions pour gérer les bénéficiaires
const addBeneficiary = () => {
  if (formData.beneficiaries.length >= MAX_BENEFICIARIES) {
    notifyError(`Vous ne pouvez pas ajouter plus de ${MAX_BENEFICIARIES} bénéficiaires.`)
    return
  }

  formData.beneficiaries.forEach(b => (b.isOpen = false))
  const newBeneficiary: BeneficiaryInfo & { isOpen: boolean } = {
    id: nextBeneficiaryId++,
    salutation: 'Monsieur',
    lastName: '',
    firstName: '',
    identityCardNumber: '',
    address: '',
    postalCode: '',
    city: '',
    functionInCompany: 'CEO',
    birthDate: '',
    birthCity: '',
    birthCountry: 'Chine',
    nationality: 'Chinois',
    sharePercentage: '',
    identityCard: null,
    identityCardBack: null,
    isOpen: true
  }
  formData.beneficiaries.push(newBeneficiary)
}

const askDeleteBeneficiary = (id: number) => {
  beneficiaryToDelete.value = id
  showDeleteModal.value = true
}

const confirmDeleteBeneficiary = async () => {
  const id = beneficiaryToDelete.value
  if (id !== null) {
    try {
      await deleteVendeurHipayBeneficiary(id)

      const index = formData.beneficiaries.findIndex(b => b.id === id)
      if (index > -1) {
        formData.beneficiaries.splice(index, 1)
        success('Bénéficiaire supprimé avec succès !')
      }
    } catch (e) {
    notifyError('Erreur lors de la suppression du bénéficiaire')
    }
  }

  showDeleteModal.value = false
  beneficiaryToDelete.value = null
}

const cancelDeleteBeneficiary = () => {
  showDeleteModal.value = false
  beneficiaryToDelete.value = null
}

const refreshExistingFiles = async () => {
  const files = await getHipayFiles()
  existingFiles.manager.identityFrontUrl = files?.manager?.identityFront || undefined
  existingFiles.manager.identityBackUrl = files?.manager?.identityBack || undefined
  existingFiles.company.ribUrl = files?.company?.rib || undefined
  existingFiles.company.kbisUrl = files?.company?.kbis || undefined
  existingFiles.company.signedArticlesUrl = files?.company?.signedArticles || undefined
  existingFiles.beneficiaries = {}
  for (const key of Object.keys(files?.beneficiaries || {})) {
    const id = Number(key)
    existingFiles.beneficiaries[id] = {
      frontUrl: files.beneficiaries[key]?.front || undefined,
      backUrl: files.beneficiaries[key]?.back || undefined,
    }
  }
}

const saveManagerSection = async () => {
  if (isSavingManager.value) return
  isSavingManager.value = true

  try {
    await saveVendeurHipayBeu({
      manager: {
        lastName: formData.manager.lastName || null,
        firstName: formData.manager.firstName || null,
      },
    })
    if (formData.manager.identityCard) {
      await uploadHipayFile(formData.manager.identityCard, 'manager_identity_front')
    }
    if (formData.manager.identityCardBack) {
      await uploadHipayFile(formData.manager.identityCardBack, 'manager_identity_back')
    }
    formData.manager.identityCard = null
    formData.manager.identityCardBack = null
    if (identityCardInput.value) identityCardInput.value.value = ''
    if (identityCardBackInput.value) identityCardBackInput.value.value = ''
    revokePreview(managerPreviews.identityCard); managerPreviews.identityCard = undefined
    revokePreview(managerPreviews.identityCardBack); managerPreviews.identityCardBack = undefined
    await refreshExistingFiles()
    success('Informations du gérant enregistrées.')
  } catch (e) {
    notifyError(e instanceof Error ? e.message : "Erreur lors de l'enregistrement du gérant.")
  } finally {
    isSavingManager.value = false
  }
}

const saveCompanySection = async () => {
  if (isSavingCompany.value) return
  isSavingCompany.value = true

  try {
    await saveVendeurHipayBeu({
      company: {
        vatNumber: formData.company.vatNumber || null,
        iban: formData.company.iban || null,
      },
    })
    if (formData.company.companyRib) {
      await uploadHipayFile(formData.company.companyRib, 'company_rib')
    }
    if (formData.company.kbisDocument) {
      await uploadHipayFile(formData.company.kbisDocument, 'company_kbis')
    }
    if (formData.company.signedArticles) {
      await uploadHipayFile(formData.company.signedArticles, 'company_signed_articles')
    }
    formData.company.companyRib = null
    formData.company.kbisDocument = null
    formData.company.signedArticles = null
    if (companyRibInput.value) companyRibInput.value.value = ''
    if (kbisInput.value) kbisInput.value.value = ''
    if (signedArticlesInput.value) signedArticlesInput.value.value = ''
    revokePreview(companyPreviews.companyRib); companyPreviews.companyRib = undefined
    revokePreview(companyPreviews.kbisDocument); companyPreviews.kbisDocument = undefined
    revokePreview(companyPreviews.signedArticles); companyPreviews.signedArticles = undefined
    await refreshExistingFiles()
    success("Informations de l’entreprise enregistrées.")
  } catch (e) {
    notifyError(e instanceof Error ? e.message : "Erreur lors de l'enregistrement de l’entreprise.")
  } finally {
    isSavingCompany.value = false
  }
}
// const removeBeneficiary = (beneficiaryId: number) => {
//   const index = formData.beneficiaries.findIndex(b => b.id === beneficiaryId)
//   if (index > -1) {
//     formData.beneficiaries.splice(index, 1)
//   }
// }

// Fonction pour sauvegarder le formulaire (+ envoi HiPay optionnel par étape)
const saveForm = async (step: BeuActionStep = pendingFormStep.value) => {
  if (isSavingForm.value) return

  try {
    if (!formData.consentAccepted) {
      notifyError("Vous devez accepter les conditions pour continuer.")
      return
    }

    const needDocs = step === 'all' || step === 'documents'
    const needBank = step === 'all' || step === 'bank'
    const needUbos = step === 'all' || step === 'ubo' || step === 'ubo_recreate'

    if (needUbos && !isTotalShareValid.value) {
      notifyError('Le total des parts des bénéficiaires ne doit pas dépasser 100%.')
      return
    }

    const hasManagerIdFront = !!formData.manager.identityCard || !!existingFiles.manager.identityFrontUrl
    if (needDocs && !hasManagerIdFront) {
      notifyError("La fiche d'identité du gérant est obligatoire pour enregistrer.")
      return
    }

    const hasCompanyRib = !!formData.company.companyRib || !!existingFiles.company.ribUrl
    const hasCompanyKbis = !!formData.company.kbisDocument || !!existingFiles.company.kbisUrl
    const hasSignedArticles = !!formData.company.signedArticles || !!existingFiles.company.signedArticlesUrl
    if (needBank && !hasCompanyRib) {
      notifyError('Le RIB est obligatoire pour cette étape.')
      return
    }
    if (needDocs && (!hasCompanyKbis || !hasSignedArticles)) {
      notifyError('Le KBIS et les statuts signés sont obligatoires pour cette étape.')
      return
    }
    if (needUbos && !hasCompanyKbis) {
      notifyError('Le KBIS est obligatoire pour envoyer les bénéficiaires.')
      return
    }
    if ((step === 'all') && (!hasCompanyRib || !hasCompanyKbis || !hasSignedArticles)) {
      notifyError('Le RIB, le KBIS et les statuts signés sont obligatoires pour enregistrer.')
      return
    }

    if (needUbos) {
      for (const b of formData.beneficiaries) {
        if (!isShareValid(b.sharePercentage)) {
          notifyError("La part de chaque bénéficiaire doit être au moins de 25% pour le KYC.")
          return
        }
        const hasBenFront = !!b.identityCard || !!existingFiles.beneficiaries[Number(b.id)]?.frontUrl
        if (!hasBenFront) {
          notifyError("La fiche d'identité de chaque bénéficiaire est obligatoire pour enregistrer.")
          return
        }
      }
    }

    const beneficiaryFiles = formData.beneficiaries.map(b => ({
      tempId: b.id,
      identityCard: b.identityCard,
      identityCardBack: b.identityCardBack,
    }))

    const payload = {
      manager: {
        lastName: formData.manager.lastName || null,
        firstName: formData.manager.firstName || null,
      },
      company: {
        vatNumber: formData.company.vatNumber || null,
        iban: formData.company.iban || null,
      },
      beneficiaries: formData.beneficiaries.map(b => ({
        id: typeof b.id === 'number' ? b.id : null,
        salutation: b.salutation || null,
        lastName: b.lastName || null,
        firstName: b.firstName || null,
        identityCardNumber: b.identityCardNumber || null,
        address: b.address || null,
        postalCode: b.postalCode || null,
        city: b.city || null,
        functionInCompany: b.functionInCompany || null,
        birthDate: b.birthDate || null,
        birthCity: b.birthCity || null,
        birthCountry: b.birthCountry || null,
        nationality: b.nationality || null,
        sharePercentage: b.sharePercentage || null,
      })),
    }

    isSavingForm.value = true
    hipayBusyStep.value = step

    const saved = await saveVendeurHipayBeu(payload)

    if (saved) {
      formData.manager.lastName = saved.manager?.lastName || ''
      formData.manager.firstName = saved.manager?.firstName || ''

      formData.company.vatNumber = saved.company?.vatNumber || ''
      formData.company.iban = saved.company?.iban || ''


      if (Array.isArray(saved.beneficiaries)) {
        formData.beneficiaries = saved.beneficiaries.map((b: any, idx: number) => {
          const files =
              beneficiaryFiles.find(f => Number(f.tempId) === Number(b.id)) ||
              beneficiaryFiles[idx]

          return {
            id: b.id ?? idx + 1,
            salutation: b.salutation || 'Monsieur',
            lastName: b.lastName || '',
            firstName: b.firstName || '',
            identityCardNumber: b.identityCardNumber || '',
            address: b.address || '',
            postalCode: b.postalCode || '',
            city: b.city || '',
            functionInCompany: b.functionInCompany || 'Autre',
            birthDate: b.birthDate || '',
            birthCity: b.birthCity || '',
            birthCountry: b.birthCountry || 'CN',
            nationality: b.nationality || 'CN',
            sharePercentage: b.sharePercentage || '',
            identityCard: files?.identityCard ?? null,
            identityCardBack: files?.identityCardBack ?? null,
            isOpen: idx === saved.beneficiaries.length - 1,
          }
        })
      }

      // （manager + company + beneficiaries）
      // --- gérant ---
      if (formData.manager.identityCard) {
        await uploadHipayFile(formData.manager.identityCard, 'manager_identity_front')
      }
      if (formData.manager.identityCardBack) {
        await uploadHipayFile(formData.manager.identityCardBack, 'manager_identity_back')
      }

      // --- company ---
      if (formData.company.companyRib) {
        await uploadHipayFile(formData.company.companyRib, 'company_rib')
      }
      if (formData.company.kbisDocument) {
        await uploadHipayFile(formData.company.kbisDocument, 'company_kbis')
      }
      if (formData.company.signedArticles) {
        await uploadHipayFile(formData.company.signedArticles, 'company_signed_articles')
      }

      // --- beneficiaries ---
      for (const b of formData.beneficiaries) {
        if (b.identityCard) {
          await uploadHipayFile(b.identityCard, 'beneficiary_identity_front', {
            beneficiaryId: Number(b.id),
          })
        }
        if (b.identityCardBack) {
          await uploadHipayFile(b.identityCardBack, 'beneficiary_identity_back', {
            beneficiaryId: Number(b.id),
          })
        }
      }


      formData.manager.lastName = saved.manager?.lastName || ''
      formData.manager.firstName = saved.manager?.firstName || ''

      formData.company.vatNumber = saved.company?.vatNumber || ''
      formData.company.iban = saved.company?.iban || ''

      if (Array.isArray(saved.beneficiaries)) {
        formData.beneficiaries = saved.beneficiaries.map((b: any, idx: number) => ({
          id: b.id ?? idx + 1,
          salutation: b.salutation || 'Monsieur',
          lastName: b.lastName || '',
          firstName: b.firstName || '',
          identityCardNumber: b.identityCardNumber || '',
          address: b.address || '',
          postalCode: b.postalCode || '',
          city: b.city || '',
          functionInCompany: b.functionInCompany || 'Autre',
          birthDate: b.birthDate || '',
          birthCity: b.birthCity || '',
          birthCountry: b.birthCountry || 'Chine',
          nationality: b.nationality || 'Chinois',
          sharePercentage: b.sharePercentage || '',
          identityCard: null,
          identityCardBack: null,
          isOpen: idx === saved.beneficiaries.length - 1,
        }))
      }

      // 4. clear <input type="file">
      if (identityCardInput.value) identityCardInput.value.value = ''
      if (identityCardBackInput.value) identityCardBackInput.value.value = ''
      if (companyRibInput.value) companyRibInput.value.value = ''
      if (kbisInput.value) kbisInput.value.value = ''
      if (signedArticlesInput.value) signedArticlesInput.value.value = ''

      // Clear previews as files were uploaded and inputs reset
      revokePreview(managerPreviews.identityCard); managerPreviews.identityCard = undefined
      revokePreview(managerPreviews.identityCardBack); managerPreviews.identityCardBack = undefined
      revokePreview(companyPreviews.companyRib); companyPreviews.companyRib = undefined
      revokePreview(companyPreviews.kbisDocument); companyPreviews.kbisDocument = undefined
      revokePreview(companyPreviews.signedArticles); companyPreviews.signedArticles = undefined
      for (const key of Object.keys(beneficiaryPreviews)) {
        const id = Number(key)
        revokePreview(beneficiaryPreviews[id]?.front); if (beneficiaryPreviews[id]) beneficiaryPreviews[id].front = undefined
        revokePreview(beneficiaryPreviews[id]?.back); if (beneficiaryPreviews[id]) beneficiaryPreviews[id].back = undefined
      }


      // Recharger les fichiers existants après sauvegarde réussie
      try {
        const files = await getHipayFiles()
        // Mapper vers existingFiles structure
        existingFiles.manager.identityFrontUrl = files?.manager?.identityFront || undefined
        existingFiles.manager.identityBackUrl = files?.manager?.identityBack || undefined
        existingFiles.company.ribUrl = files?.company?.rib || undefined
        existingFiles.company.kbisUrl = files?.company?.kbis || undefined
        existingFiles.company.signedArticlesUrl = files?.company?.signedArticles || undefined
        existingFiles.beneficiaries = {}
        if (files?.beneficiaries) {
          for (const key of Object.keys(files.beneficiaries)) {
            const id = Number(key)
            existingFiles.beneficiaries[id] = {
              frontUrl: files.beneficiaries[key]?.front || undefined,
              backUrl: files.beneficiaries[key]?.back || undefined,
            }
          }
        }
      } catch (e) {
        // Erreur silencieuse lors de la récupération des fichiers après sauvegarde
        console.warn('Erreur lors de la récupération des fichiers après sauvegarde:', e)
      }

      try {
          const hipayResult = await submitVendeurHipayAccount(step)
          if (step === 'ubo' || step === 'ubo_recreate') {
            uboRecreateRequired.value = false
          }
          success(hipayResult?.message || 'Envoi HiPay réussi.')
        } catch (hipayErr) {
          const rawMsg =
            hipayErr instanceof Error ? hipayErr.message : "Erreur lors de l'envoi HiPay."
          const hipayMsg = rawMsg.toLowerCase().includes('cannot be edited anymore') ||
            rawMsg.toLowerCase().includes('ubo statement has been submitted')
            ? "La modification des bénéficiaires n'est plus possible : la déclaration UBO a déjà été soumise à HiPay. Veuillez contacter le service client eFashion pour effectuer un changement."
            : rawMsg.replace('[UBO_CONFIRMATION_REQUIRED] ', '')
          if (rawMsg.includes('[UBO_CONFIRMATION_REQUIRED]')) {
            uboRecreateRequired.value = true
          }
          notifyError(`Données enregistrées, mais l'envoi HiPay a échoué : ${hipayMsg}`)
        }
    }
  } catch (e) {
    const message = e instanceof Error ? e.message : "Erreur lors de la sauvegarde du formulaire."
    notifyError(message)
  } finally {
    isSavingForm.value = false
    hipayBusyStep.value = null
  }
}

const openSaveBeneficiaryModal = (b: any) => {
  beneficiaryToSave.value = b
  showSaveBeneficiaryModal.value = true
}

const confirmSaveBeneficiary = async () => {
  if (!beneficiaryToSave.value) return
  await saveOneBeneficiary(beneficiaryToSave.value)
  showSaveBeneficiaryModal.value = false
  beneficiaryToSave.value = null
}

const saveOneBeneficiary = async (b: any) => {

  if (!isShareValid(b.sharePercentage)) {
    notifyError("La part de ce bénéficiaire doit être au moins de 25% pour le KYC.")
    return
  }

  const identityCard = b.identityCard as File | null
  const identityCardBack = b.identityCardBack as File | null

  if (!identityCard && !existingFiles.beneficiaries[Number(b.id)]?.frontUrl) {
    notifyError("La fiche d'identité du bénéficiaire est obligatoire pour enregistrer.")
    return
  }
  const input = {
    id: typeof b.id === 'number' ? b.id : null,
    salutation: b.salutation || null,
    lastName: b.lastName || null,
    firstName: b.firstName || null,
    identityCardNumber: b.identityCardNumber || null,
    address: b.address || null,
    postalCode: b.postalCode || null,
    city: b.city || null,
    functionInCompany: b.functionInCompany || null,
    birthDate: b.birthDate || null,
    birthCity: b.birthCity || null,
    birthCountry: b.birthCountry || null,
    nationality: b.nationality || null,
    sharePercentage: b.sharePercentage || null,
  }

  try {
    const saved = await saveVendeurHipayBeneficiary(input)
    const savedId = Number(saved.id)

    if (identityCard) {
      await uploadHipayFile(identityCard, 'beneficiary_identity_front', {
        beneficiaryId: savedId,
      })
    }
    if (identityCardBack) {
      await uploadHipayFile(identityCardBack, 'beneficiary_identity_back', {
        beneficiaryId: savedId,
      })
    }

    const idx = formData.beneficiaries.findIndex(x => x.id === b.id)
    if (idx > -1) {
      formData.beneficiaries[idx] = {
        ...formData.beneficiaries[idx],
        ...saved,
        isOpen: true,
        identityCard: null,
        identityCardBack: null,
      }
    } else {
      formData.beneficiaries.push({
        ...saved,
        isOpen: true,
        identityCard: null,
        identityCardBack: null,
      })
    }

    await refreshExistingFiles()

    success('Bénéficiaire enregistré avec succès !')
  } catch (e) {
    notifyError("Erreur lors de l'enregistrement du bénéficiaire")
  }
}

const openSaveFormModal = (step: BeuActionStep = 'all') => {
  if (isBusy.value) return
  pendingFormStep.value = step
  showSaveFormModal.value = true
}

const confirmSaveForm = async () => {
  if (isBusy.value) return
  showSaveFormModal.value = false
  await saveForm(pendingFormStep.value)
}

const openDeleteUboStatementModal = () => {
  if (isBusy.value) return
  showDeleteUboStatementModal.value = true
}

const confirmDeleteUboStatement = async () => {
  if (isBusy.value) return
  showDeleteUboStatementModal.value = false
  isDeletingUboStatement.value = true
  try {
    const result = await deleteVendeurHipayUboStatement()
    if (result?.success) {
      success(result.message || 'Déclaration UBO supprimée chez HiPay.')
    } else {
      notifyError(result?.message || 'Échec de la suppression du UBO statement.')
    }
  } catch (e) {
    notifyError(e instanceof Error ? e.message : 'Erreur lors de la suppression du UBO statement.')
  } finally {
    isDeletingUboStatement.value = false
  }
}

/**  Validation  **/
const isVatValid = (value: string) => {
  const v = (value || '').replace(/\s/g, '').toUpperCase()

  const vatRegex = /^FR[0-9A-Z]{2}[0-9]{9}$/
  return vatRegex.test(v)
}

const isIbanValid = (value: string) => {
  const v = (value || '').replace(/\s/g, '').toUpperCase()
  // IBAN FR
  // const ibanRegex = /^FR[0-9]{2}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{3}$/
  const ibanRegex = /^FR[0-9]{2}(?: ?[A-Z0-9]{4}){5} ?[A-Z0-9]{3}$/
  return v.length === 27 && ibanRegex.test(v)
}

const isPostalCodeValid = (value: string) => {
  const v = (value || '').trim()
  return /^[0-9]{5}$/.test(v)
}

const vatStatusClass = () => {
  const v = formData.company.vatNumber || ''
  if (!v) return 'border-red-500 bg-red-50'
  return isVatValid(v) ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'
}

const ibanStatusClass = () => {
  const v = formData.company.iban || ''
  if (!v) return 'border-red-500 bg-red-50'
  return isIbanValid(v) ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'
}

const postalStatusClass = (beneficiary: any) => {
  const v = beneficiary.postalCode || ''
  if (!v) return 'border-red-500 bg-red-50'
  return isPostalCodeValid(v) ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'
}

const formatIban = (value: string) => {
  const cleanValue = value.replace(/\s/g, '')
  return cleanValue.replace(/(.{4})/g, '$1 ').trim()
}
const handlePostalCodeInput = (event: Event, beneficiary: any) => {
  const target = event.target as HTMLInputElement
  const clean = target.value.replace(/\D/g, '').slice(0, 5)
  beneficiary.postalCode = clean
}

const isShareValid = (value: string | number) => {
  const num = parseFloat(String(value ?? '').replace(',', '.'))
  return !isNaN(num) && num >= 25
}
const shareStatusClass = (beneficiary: any) => {
  const v = beneficiary.sharePercentage || ''
  if (!v) return 'border-red-500 bg-red-50'
  return isShareValid(v) ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'
}



watch(
    () => formData.company.iban,
    (val) => {
      if (!val) return
      const clean = val.replace(/\s/g, '').toUpperCase().slice(0, 27)
      const formatted = formatIban(clean)
      if (formatted !== val) {
        formData.company.iban = formatted
      }
    }
)
watch(
    () => formData.company.vatNumber,
    (val) => {
      if (val == null) return
      const formatted = val.replace(/\s/g, '').toUpperCase()
      if (formatted !== val) {
        formData.company.vatNumber = formatted
      }
    }
)

// Lifecycle
onMounted(async () => {
  // Initialisation si nécessaire

  if (!authStore.isInitialized) {
    await authStore.checkAuth()
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: 'auth' })
    return
  }
  await loadHipayBeu()
  // Précharger les fichiers Hipay pour afficher les fichiers existants
  // Nécessaire pour que les fichiers sauvegardés soient visibles après validation
  const shouldPreloadHipayFiles = true
  if (shouldPreloadHipayFiles) {
    // Charger les fichiers existants pour affichage après rafraîchissement
    try {
      const files = await getHipayFiles()
      // Mapper vers existingFiles structure
      existingFiles.manager.identityFrontUrl = files?.manager?.identityFront || undefined
      existingFiles.manager.identityBackUrl = files?.manager?.identityBack || undefined
      existingFiles.company.ribUrl = files?.company?.rib || undefined
      existingFiles.company.kbisUrl = files?.company?.kbis || undefined
      existingFiles.company.signedArticlesUrl = files?.company?.signedArticles || undefined
      existingFiles.beneficiaries = {}
      if (files?.beneficiaries) {
        for (const key of Object.keys(files.beneficiaries)) {
          const id = Number(key)
          existingFiles.beneficiaries[id] = {
            frontUrl: files.beneficiaries[key]?.front || undefined,
            backUrl: files.beneficiaries[key]?.back || undefined,
          }
        }
      }
    } catch (e) {
      // silently ignore listing errors
      // Erreur silencieuse lors de la récupération des fichiers
    }
  }
})

// Computed: total share of beneficiaries must not exceed 100
const totalShare = computed(() => {
  return formData.beneficiaries.reduce((sum, b) => {
    const num = parseFloat(String(b.sharePercentage || '').replace(',', '.'))
    return sum + (isNaN(num) ? 0 : num)
  }, 0)
})
const isTotalShareValid = computed(() => totalShare.value <= 100)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageHeader), {
      title: "Informations BEU",
      subtitle: "Bénéficiaire Effectif Ultime"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"])),
        class: "space-y-8"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "mb-6 p-4 rounded-lg bg-blue-50 border border-blue-200 text-sm text-blue-900" }, [
            _createElementVNode("p", { class: "font-semibold mb-1" }, [
              _createElementVNode("i", { class: "fas fa-shield-alt mr-2" }),
              _createTextVNode("Informations nécessaires à la vérification HiPay")
            ]),
            _createElementVNode("p", null, "Complétez les informations et documents du gérant, de l’entreprise et de chaque bénéficiaire effectif. Le nom de l’entreprise indiqué sur le RIB et sur le KBIS doit être identique à celui renseigné dans le dossier ; sinon HiPay peut refuser la vérification.")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-lg font-semibold text-black mb-6 flex items-center gap-2" }, [
                _createElementVNode("i", { class: "fas fa-user-tie text-blue-600" }),
                _createTextVNode(" Informations Gérant ")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Nom", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.manager.lastName) = $event)),
                      type: "text",
                      class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                      placeholder: "Votre nom"
                    }, null, 512), [
                      [_vModelText, formData.manager.lastName]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Prénom", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.manager.firstName) = $event)),
                      type: "text",
                      class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                      placeholder: "Votre prénom"
                    }, null, 512), [
                      [_vModelText, formData.manager.firstName]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Fiche d'identité", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("input", {
                        ref_key: "identityCardInput",
                        ref: identityCardInput,
                        type: "file",
                        accept: ".jpg,.jpeg,.gif,.png,.pdf",
                        onChange: handleIdentityCardUpload,
                        class: "hidden"
                      }, null, 544),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (triggerFileInput('identityCardInput'))),
                        class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                      }, " Choisir un fichier "),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(formData.manager.identityCard
                             ? formData.manager.identityCard.name
                             : (existingFiles.manager.identityFrontUrl ? fileNameFromUrl(existingFiles.manager.identityFrontUrl) : 'Aucun fichier choisi')), 1),
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (managerPreviews.identityCard)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                href: managerPreviews.identityCard.url,
                                target: "_blank",
                                class: "text-blue-600 text-xs underline"
                              }, "Prévisualiser", 8, _hoisted_13),
                              (managerPreviews.identityCard.isImage)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: managerPreviews.identityCard.url,
                                    alt: "Prévisualisation",
                                    class: "h-12 w-auto rounded border"
                                  }, null, 8, _hoisted_14))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (existingFiles.manager.identityFrontUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: existingFiles.manager.identityFrontUrl,
                                target: "_blank",
                                class: "text-blue-600 text-xs underline"
                              }, "Voir le fichier", 8, _hoisted_15))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("input", {
                        ref_key: "identityCardBackInput",
                        ref: identityCardBackInput,
                        type: "file",
                        accept: ".jpg,.jpeg,.gif,.png,.pdf",
                        onChange: handleIdentityCardBackUpload,
                        class: "hidden"
                      }, null, 544),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (triggerFileInput('identityCardBackInput'))),
                        class: "px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm"
                      }, " Ajouter verso "),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(formData.manager.identityCardBack
                             ? formData.manager.identityCardBack.name
                             : (existingFiles.manager.identityBackUrl ? fileNameFromUrl(existingFiles.manager.identityBackUrl) : 'Aucun fichier choisi')), 1),
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        (managerPreviews.identityCardBack)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                href: managerPreviews.identityCardBack.url,
                                target: "_blank",
                                class: "text-blue-600 text-xs underline"
                              }, "Prévisualiser", 8, _hoisted_20),
                              (managerPreviews.identityCardBack.isImage)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: managerPreviews.identityCardBack.url,
                                    alt: "Prévisualisation",
                                    class: "h-12 w-auto rounded border"
                                  }, null, 8, _hoisted_21))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (existingFiles.manager.identityBackUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: existingFiles.manager.identityBackUrl,
                                target: "_blank",
                                class: "text-blue-600 text-xs underline"
                              }, "Voir le fichier", 8, _hoisted_22))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm disabled:opacity-60 inline-flex items-center gap-2",
                  disabled: isSavingManager.value,
                  onClick: saveManagerSection
                }, [
                  _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(isSavingManager.value ? 'Enregistrement…' : 'Enregistrer le gérant'), 1)
                ], 8, _hoisted_24)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[47] || (_cache[47] = _createElementVNode("h3", { class: "text-lg font-semibold text-black mb-6 flex items-center gap-2" }, [
                _createElementVNode("i", { class: "fas fa-building text-green-600" }),
                _createTextVNode(" Informations Entreprise ")
              ], -1)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
                      _createTextVNode("Numéro de TVA "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.company.vatNumber) = $event)),
                        type: "text",
                        class: _normalizeClass(["w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500", vatStatusClass()]),
                        placeholder: "Numéro de TVA"
                      }, null, 2), [
                        [_vModelText, formData.company.vatNumber]
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                    ]),
                    (!formData.company.vatNumber)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _cache[30] || (_cache[30] = [
                          _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                          _createTextVNode(" Numéro de TVA obligatoire ")
                        ])))
                      : (!isVatValid(formData.company.vatNumber))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, _cache[31] || (_cache[31] = [
                            _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                            _createTextVNode(" Format TVA invalide. Exemple : FRXX999999999 ")
                          ])))
                        : (_openBlock(), _createElementBlock("p", _hoisted_31, _cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1),
                            _createTextVNode(" Format TVA valide ")
                          ])))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
                      _createTextVNode(" IBAN "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.company.iban) = $event)),
                        type: "text",
                        maxlength: 35,
                        class: _normalizeClass(["w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500", ibanStatusClass()]),
                        placeholder: "FR76 3000 1007 9416 0000 0000 000"
                      }, null, 2), [
                        [_vModelText, formData.company.iban]
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                    ]),
                    (!formData.company.iban)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, _cache[35] || (_cache[35] = [
                          _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                          _createTextVNode(" IBAN obligatoire ")
                        ])))
                      : (!isIbanValid(formData.company.iban))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, _cache[36] || (_cache[36] = [
                            _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                            _createTextVNode(" Format IBAN invalide. Exemple : FR76 3000 1007 9416 0000 0000 000 ")
                          ])))
                        : (_openBlock(), _createElementBlock("p", _hoisted_35, _cache[37] || (_cache[37] = [
                            _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1),
                            _createTextVNode(" Format IBAN valide ")
                          ])))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "RIB de la société", -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("input", {
                      ref_key: "companyRibInput",
                      ref: companyRibInput,
                      type: "file",
                      accept: ".jpg,.jpeg,.gif,.png,.pdf",
                      onChange: handleCompanyRibUpload,
                      class: "hidden"
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (triggerFileInput('companyRibInput'))),
                      class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    }, " Choisir un fichier "),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, _toDisplayString(formData.company.companyRib
                           ? formData.company.companyRib.name
                           : (existingFiles.company.ribUrl ? fileNameFromUrl(existingFiles.company.ribUrl) : 'Aucun fichier choisi')), 1),
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1))
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      (companyPreviews.companyRib)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("a", {
                              href: companyPreviews.companyRib.url,
                              target: "_blank",
                              class: "text-blue-600 text-xs underline"
                            }, "Prévisualiser", 8, _hoisted_40),
                            (companyPreviews.companyRib.isImage)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: companyPreviews.companyRib.url,
                                  alt: "Prévisualisation",
                                  class: "h-12 w-auto rounded border"
                                }, null, 8, _hoisted_41))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (existingFiles.company.ribUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: existingFiles.company.ribUrl,
                              target: "_blank",
                              class: "text-blue-600 text-xs underline"
                            }, "Voir le fichier", 8, _hoisted_42))
                          : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Kbis datant de moins de 3 mois", -1)),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("input", {
                      ref_key: "kbisInput",
                      ref: kbisInput,
                      type: "file",
                      accept: ".jpg,.jpeg,.gif,.png,.pdf",
                      onChange: handleKbisUpload,
                      class: "hidden"
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (triggerFileInput('kbisInput'))),
                      class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    }, " Choisir un fichier "),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(formData.company.kbisDocument
                           ? formData.company.kbisDocument.name
                           : (existingFiles.company.kbisUrl ? fileNameFromUrl(existingFiles.company.kbisUrl) : 'Aucun fichier choisi')), 1),
                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1))
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      (companyPreviews.kbisDocument)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("a", {
                              href: companyPreviews.kbisDocument.url,
                              target: "_blank",
                              class: "text-blue-600 text-xs underline"
                            }, "Prévisualiser", 8, _hoisted_47),
                            (companyPreviews.kbisDocument.isImage)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: companyPreviews.kbisDocument.url,
                                  alt: "Prévisualisation",
                                  class: "h-12 w-auto rounded border"
                                }, null, 8, _hoisted_48))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (existingFiles.company.kbisUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: existingFiles.company.kbisUrl,
                              target: "_blank",
                              class: "text-blue-600 text-xs underline"
                            }, "Voir le fichier", 8, _hoisted_49))
                          : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Statuts signés avec répartition des pouvoirs", -1)),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("input", {
                        ref_key: "signedArticlesInput",
                        ref: signedArticlesInput,
                        type: "file",
                        accept: ".jpg,.jpeg,.gif,.png,.pdf",
                        onChange: handleSignedArticlesUpload,
                        class: "hidden"
                      }, null, 544),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (triggerFileInput('signedArticlesInput'))),
                        class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                      }, " Choisir un fichier "),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("span", _hoisted_53, _toDisplayString(formData.company.signedArticles
                             ? formData.company.signedArticles.name
                             : (existingFiles.company.signedArticlesUrl ? fileNameFromUrl(existingFiles.company.signedArticlesUrl) : 'Aucun fichier choisi')), 1),
                        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1))
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        (companyPreviews.signedArticles)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                href: companyPreviews.signedArticles.url,
                                target: "_blank",
                                class: "text-blue-600 text-xs underline"
                              }, "Prévisualiser", 8, _hoisted_55),
                              (companyPreviews.signedArticles.isImage)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: companyPreviews.signedArticles.url,
                                    alt: "Prévisualisation",
                                    class: "h-12 w-auto rounded border"
                                  }, null, 8, _hoisted_56))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (existingFiles.company.signedArticlesUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: existingFiles.company.signedArticlesUrl,
                                target: "_blank",
                                class: "text-blue-600 text-xs underline"
                              }, "Voir le fichier", 8, _hoisted_57))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-xs text-black" }, " Incluant l'adresse du siège social, le nom de l'entreprise et le nom du représentant légal ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm disabled:opacity-60 inline-flex items-center gap-2",
                  disabled: isSavingCompany.value,
                  onClick: saveCompanySection
                }, [
                  _cache[46] || (_cache[46] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(isSavingCompany.value ? 'Enregistrement…' : 'Enregistrer l’entreprise'), 1)
                ], 8, _hoisted_59)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "text-lg font-semibold text-black flex items-center gap-2" }, [
              _createElementVNode("i", { class: "fas fa-users text-purple-600" }),
              _createTextVNode(" Informations BEU (Bénéficiaire Effectif Ultime) ")
            ], -1)),
            _cache[51] || (_cache[51] = _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, " Ajoutez chaque bénéficiaire détenant au moins 25 % de l’entreprise. ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: addBeneficiary,
              class: _normalizeClass([
                        'px-4 py-2 rounded-lg text-white transition-colors inline-flex items-center gap-2',
                        formData.beneficiaries.length >= 4
                          ? 'bg-gray-300 cursor-not-allowed'
                          : 'bg-green-600 hover:bg-green-700'
                        ])
            }, _cache[49] || (_cache[49] = [
              _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
              _createTextVNode(" Ajouter un bénéficiaire ")
            ]), 2)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.beneficiaries, (beneficiary, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: beneficiary.id,
              class: "mb-4 rounded-lg bg-white border border-gray-200"
            }, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (beneficiary.isOpen = !beneficiary.isOpen),
                class: "w-full flex items-center justify-between px-4 py-3"
              }, [
                _createElementVNode("span", _hoisted_63, "Bénéficiaire " + _toDisplayString(index + 1), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(['transition-transform duration-200', beneficiary.isOpen ? 'rotate-180' : ''])
                }, "▼", 2)
              ], 8, _hoisted_62),
              _createVNode(_Transition, { name: "accordion" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", null, [
                        _cache[53] || (_cache[53] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Civilité", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.salutation) = $event),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        }, _cache[52] || (_cache[52] = [
                          _createElementVNode("option", { value: "Monsieur" }, "Monsieur", -1),
                          _createElementVNode("option", { value: "Madame" }, "Madame", -1)
                        ]), 8, _hoisted_66), [
                          [_vModelSelect, beneficiary.salutation]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[55] || (_cache[55] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Nom", -1)),
                        _createElementVNode("div", _hoisted_67, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((beneficiary.lastName) = $event),
                            type: "text",
                            class: "w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                            placeholder: "Nom"
                          }, null, 8, _hoisted_68), [
                            [_vModelText, beneficiary.lastName]
                          ]),
                          _cache[54] || (_cache[54] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[56] || (_cache[56] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Prénom", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.firstName) = $event),
                          type: "text",
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                          placeholder: "Prénom"
                        }, null, 8, _hoisted_69), [
                          [_vModelText, beneficiary.firstName]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[58] || (_cache[58] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Numéro de carte d'identité", -1)),
                        _createElementVNode("div", _hoisted_70, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((beneficiary.identityCardNumber) = $event),
                            type: "text",
                            class: "w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                            placeholder: "Numéro d'identité"
                          }, null, 8, _hoisted_71), [
                            [_vModelText, beneficiary.identityCardNumber]
                          ]),
                          _cache[57] || (_cache[57] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[60] || (_cache[60] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Adresse", -1)),
                        _createElementVNode("div", _hoisted_72, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((beneficiary.address) = $event),
                            type: "text",
                            class: "w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                            placeholder: "Adresse"
                          }, null, 8, _hoisted_73), [
                            [_vModelText, beneficiary.address]
                          ]),
                          _cache[59] || (_cache[59] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[65] || (_cache[65] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
                          _createTextVNode("Code postal "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_74, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((beneficiary.postalCode) = $event),
                            onInput: ($event: any) => (handlePostalCodeInput($event, beneficiary)),
                            type: "text",
                            class: _normalizeClass(["w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500", postalStatusClass(beneficiary)]),
                            placeholder: "Code postal"
                          }, null, 42, _hoisted_75), [
                            [_vModelText, beneficiary.postalCode]
                          ]),
                          _cache[61] || (_cache[61] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                        ]),
                        (!beneficiary.postalCode)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_76, _cache[62] || (_cache[62] = [
                              _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                              _createTextVNode(" Code postal obligatoire ")
                            ])))
                          : (!isPostalCodeValid(beneficiary.postalCode))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_77, _cache[63] || (_cache[63] = [
                                _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                                _createTextVNode(" Code postal invalide. Exemple : 75001 ")
                              ])))
                            : (_openBlock(), _createElementBlock("p", _hoisted_78, _cache[64] || (_cache[64] = [
                                _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1),
                                _createTextVNode(" Code postal valide ")
                              ])))
                      ]),
                      _createElementVNode("div", null, [
                        _cache[67] || (_cache[67] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Ville", -1)),
                        _createElementVNode("div", _hoisted_79, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((beneficiary.city) = $event),
                            type: "text",
                            class: "w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                            placeholder: "Ville"
                          }, null, 8, _hoisted_80), [
                            [_vModelText, beneficiary.city]
                          ]),
                          _cache[66] || (_cache[66] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[69] || (_cache[69] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Fonction dans l'entreprise", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.functionInCompany) = $event),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        }, _cache[68] || (_cache[68] = [
                          _createElementVNode("option", { value: "CEO" }, "CEO", -1),
                          _createElementVNode("option", { value: "COO" }, "COO", -1),
                          _createElementVNode("option", { value: "CFO" }, "CFO", -1),
                          _createElementVNode("option", { value: "Actionnaire" }, "Actionnaire", -1),
                          _createElementVNode("option", { value: "Administrateur" }, "Administrateur", -1),
                          _createElementVNode("option", { value: "Autre" }, "Autre", -1),
                          _createElementVNode("option", { value: "Directeur d'entreprise" }, "Directeur d'entreprise", -1)
                        ]), 8, _hoisted_81), [
                          [_vModelSelect, beneficiary.functionInCompany]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[70] || (_cache[70] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Date de naissance", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.birthDate) = $event),
                          type: "date",
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        }, null, 8, _hoisted_82), [
                          [_vModelText, beneficiary.birthDate]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[72] || (_cache[72] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Ville de naissance", -1)),
                        _createElementVNode("div", _hoisted_83, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((beneficiary.birthCity) = $event),
                            type: "text",
                            class: "w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                            placeholder: "Ville de naissance"
                          }, null, 8, _hoisted_84), [
                            [_vModelText, beneficiary.birthCity]
                          ]),
                          _cache[71] || (_cache[71] = _createElementVNode("i", { class: "fas fa-chart-line absolute right-3 top-1/2 transform -translate-y-1/2 text-black" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[73] || (_cache[73] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Pays de naissance", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.birthCountry) = $event),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countryOptions, (c) => {
                            return _createElementVNode("option", {
                              key: c.code,
                              value: c.code
                            }, _toDisplayString(c.label), 9, _hoisted_86)
                          }), 64))
                        ], 8, _hoisted_85), [
                          [_vModelSelect, beneficiary.birthCountry]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[74] || (_cache[74] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Nationalité", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.nationality) = $event),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nationalityOptions, (n) => {
                            return _createElementVNode("option", {
                              key: n.code,
                              value: n.code
                            }, _toDisplayString(n.label), 9, _hoisted_88)
                          }), 64))
                        ], 8, _hoisted_87), [
                          [_vModelSelect, beneficiary.nationality]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[79] || (_cache[79] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
                          _createTextVNode(" Part "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((beneficiary.sharePercentage) = $event),
                          onInput: ($event: any) => (handleShareInput($event, beneficiary)),
                          type: "text",
                          class: _normalizeClass(["w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500", shareStatusClass(beneficiary)]),
                          placeholder: "Pourcentage"
                        }, null, 42, _hoisted_89), [
                          [_vModelText, beneficiary.sharePercentage]
                        ]),
                        (!beneficiary.sharePercentage)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_90, _cache[75] || (_cache[75] = [
                              _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                              _createTextVNode(" Part obligatoire (minimum 25%). ")
                            ])))
                          : (!isShareValid(beneficiary.sharePercentage))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_91, _cache[76] || (_cache[76] = [
                                _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1),
                                _createTextVNode(" La part doit être au moins de 25% pour le KYC. ")
                              ])))
                            : (!isTotalShareValid.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_92, [
                                  _cache[77] || (_cache[77] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1)),
                                  _createTextVNode(" Total des parts: " + _toDisplayString(totalShare.value) + "% (le total ne doit pas dépasser 100%). ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_93, _cache[78] || (_cache[78] = [
                                  _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1),
                                  _createTextVNode(" Part valide. ")
                                ])))
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _cache[82] || (_cache[82] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Fiche d'identité", -1)),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("input", {
                              ref_for: true,
                              ref: `beneficiaryIdentityCardInput${beneficiary.id}`,
                              type: "file",
                              accept: ".jpg,.jpeg,.gif,.png,.pdf",
                              onChange: (event) => handleBeneficiaryIdentityCardUpload(event, beneficiary.id),
                              class: "hidden"
                            }, null, 40, _hoisted_97),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (triggerBeneficiaryFileInput(beneficiary.id)),
                              class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                            }, " Choisir un fichier ", 8, _hoisted_98),
                            _createElementVNode("span", _hoisted_99, _toDisplayString(beneficiary.identityCard
                             ? beneficiary.identityCard.name
                             : (existingFiles.beneficiaries[beneficiary.id]?.frontUrl ? fileNameFromUrl(existingFiles.beneficiaries[beneficiary.id]?.frontUrl) : 'Aucun fichier choisi')), 1),
                            _cache[80] || (_cache[80] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1)),
                            _createElementVNode("div", _hoisted_100, [
                              (beneficiaryPreviews[beneficiary.id] && beneficiaryPreviews[beneficiary.id].front)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("a", {
                                      href: beneficiaryPreviews[beneficiary.id].front.url,
                                      target: "_blank",
                                      class: "text-blue-600 text-xs underline"
                                    }, "Prévisualiser", 8, _hoisted_101),
                                    (beneficiaryPreviews[beneficiary.id].front.isImage)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: beneficiaryPreviews[beneficiary.id].front.url,
                                          alt: "Prévisualisation",
                                          class: "h-16 w-auto rounded border"
                                        }, null, 8, _hoisted_102))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (existingFiles.beneficiaries[beneficiary.id]?.frontUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: existingFiles.beneficiaries[beneficiary.id].frontUrl,
                                      target: "_blank",
                                      class: "text-blue-600 text-xs underline"
                                    }, "Voir le fichier", 8, _hoisted_103))
                                  : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("input", {
                              ref_for: true,
                              ref: `beneficiaryIdentityCardBackInput${beneficiary.id}`,
                              type: "file",
                              accept: ".jpg,.jpeg,.gif,.png,.pdf",
                              onChange: (event) => handleBeneficiaryIdentityCardBackUpload(event, beneficiary.id),
                              class: "hidden"
                            }, null, 40, _hoisted_105),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (triggerBeneficiaryBackFileInput(beneficiary.id)),
                              class: "px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm"
                            }, " Ajouter verso ", 8, _hoisted_106),
                            _createElementVNode("span", _hoisted_107, _toDisplayString(beneficiary.identityCardBack
                               ? beneficiary.identityCardBack.name
                               : (existingFiles.beneficiaries[beneficiary.id]?.backUrl ? fileNameFromUrl(existingFiles.beneficiaries[beneficiary.id]?.backUrl) : 'Aucun fichier choisi')), 1),
                            _cache[81] || (_cache[81] = _createElementVNode("span", { class: "text-xs text-black" }, "(jpg, jpeg, gif, png, pdf)", -1)),
                            _createElementVNode("div", _hoisted_108, [
                              (beneficiaryPreviews[beneficiary.id] && beneficiaryPreviews[beneficiary.id].back)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("a", {
                                      href: beneficiaryPreviews[beneficiary.id].back.url,
                                      target: "_blank",
                                      class: "text-blue-600 text-xs underline"
                                    }, "Prévisualiser", 8, _hoisted_109),
                                    (beneficiaryPreviews[beneficiary.id].back.isImage)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: beneficiaryPreviews[beneficiary.id].back.url,
                                          alt: "Prévisualisation",
                                          class: "h-16 w-auto rounded border"
                                        }, null, 8, _hoisted_110))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (existingFiles.beneficiaries[beneficiary.id]?.backUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: existingFiles.beneficiaries[beneficiary.id].backUrl,
                                      target: "_blank",
                                      class: "text-blue-600 text-xs underline"
                                    }, "Voir le fichier", 8, _hoisted_111))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "beu-btn px-4 py-2 mr-3 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm inline-flex items-center gap-2",
                        onClick: ($event: any) => (openSaveBeneficiaryModal(beneficiary))
                      }, _cache[83] || (_cache[83] = [
                        _createElementVNode("i", { class: "fas fa-save" }, null, -1),
                        _createTextVNode(" Enregistrer ")
                      ]), 8, _hoisted_113),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (askDeleteBeneficiary(beneficiary.id)),
                        class: "beu-btn px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
                      }, " Supprimer ", 8, _hoisted_114)
                    ])
                  ], 512), [
                    [_vShow, beneficiary.isOpen]
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_115, [
          _createElementVNode("div", _hoisted_116, [
            _cache[98] || (_cache[98] = _createElementVNode("div", { class: "flex items-start gap-3 p-4 bg-gray-100 rounded-lg" }, [
              _createElementVNode("i", { class: "fas fa-info-circle text-black mt-1" }),
              _createElementVNode("p", { class: "text-sm text-black" }, " En raison des limitations du serveur, la taille maximale d'un fichier individuel est de 3 Mo, et la taille totale des fichiers ne doit pas dépasser 6 Mo. Si vos fichiers sont volumineux, vous devrez peut-être les télécharger en plusieurs fois. ")
            ], -1)),
            _createElementVNode("div", _hoisted_117, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.consentAccepted) = $event)),
                type: "checkbox",
                id: "consent",
                class: "w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2"
              }, null, 512), [
                [_vModelCheckbox, formData.consentAccepted]
              ]),
              _cache[84] || (_cache[84] = _createElementVNode("label", {
                for: "consent",
                class: "text-sm font-medium text-red-600"
              }, " J'accepte que mes données soient utilisées uniquement pour la création d'un compte bancaire. ", -1))
            ]),
            (!isAdminHipayTools.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                    disabled: isBusy.value,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (openSaveFormModal('all')))
                  }, [
                    (hipayBusyStep.value === 'all')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_120))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(hipayBusyStep.value === 'all' ? 'Enregistrement et envoi HiPay…' : 'Demander la validation HiPay'), 1)
                  ], 8, _hoisted_119)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[97] || (_cache[97] = _createElementVNode("p", { class: "text-sm text-gray-600 text-center" }, " Mode admin : chaque bouton enregistre puis appelle un endpoint HiPay distinct. ", -1)),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _cache[85] || (_cache[85] = _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "font-semibold text-blue-950" }, "Statuts HiPay de ce vendeur"),
                        _createElementVNode("p", { class: "text-xs text-blue-800" }, "La recherche utilise aussi l’e-mail si aucun account_id n’est enregistré localement.")
                      ], -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800 transition-colors text-sm font-medium disabled:opacity-60 inline-flex items-center gap-2",
                        disabled: isBusy.value || isRefreshingHipayStatus.value,
                        onClick: refreshCurrentHipayStatus
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-rotate-right", { 'fa-spin': isRefreshingHipayStatus.value }])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(isRefreshingHipayStatus.value ? 'Actualisation…' : 'Actualiser les statuts HiPay'), 1)
                      ], 8, _hoisted_123)
                    ]),
                    (hipayVendorStatus.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                          _createElementVNode("div", _hoisted_125, [
                            _cache[86] || (_cache[86] = _createElementVNode("span", { class: "block text-gray-500 text-xs" }, "Compte", -1)),
                            _createElementVNode("strong", null, _toDisplayString(hipayVendorStatus.value.accountStatus), 1),
                            (hipayVendorStatus.value.accountId)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_126, "#" + _toDisplayString(hipayVendorStatus.value.accountId), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_127, [
                            _cache[87] || (_cache[87] = _createElementVNode("span", { class: "block text-gray-500 text-xs" }, "KYC", -1)),
                            _createElementVNode("strong", null, _toDisplayString(hipayVendorStatus.value.kycStatus || 'Non vérifié'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_128, [
                            _cache[88] || (_cache[88] = _createElementVNode("span", { class: "block text-gray-500 text-xs" }, "Banque", -1)),
                            _createElementVNode("strong", null, _toDisplayString(hipayVendorStatus.value.bankStatus), 1)
                          ]),
                          _createElementVNode("div", _hoisted_129, [
                            _cache[89] || (_cache[89] = _createElementVNode("span", { class: "block text-gray-500 text-xs" }, "UBO", -1)),
                            _createElementVNode("strong", null, _toDisplayString(hipayVendorStatus.value.uboStatus || 'À compléter'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value,
                      title: "PATCH /user-account (création si le compte n’existe pas)",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (openSaveFormModal('account')))
                    }, [
                      (hipayBusyStep.value === 'account')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_132))
                        : _createCommentVNode("", true),
                      _cache[90] || (_cache[90] = _createTextVNode(" Envoyer les informations du compte "))
                    ], 8, _hoisted_131),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value,
                      title: "POST /identification",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (openSaveFormModal('documents')))
                    }, [
                      (hipayBusyStep.value === 'documents')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_134))
                        : _createCommentVNode("", true),
                      _cache[91] || (_cache[91] = _createTextVNode(" Envoyer documents KYC "))
                    ], 8, _hoisted_133),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value,
                      title: "POST /user-account/bank-info",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (openSaveFormModal('bank')))
                    }, [
                      (hipayBusyStep.value === 'bank')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_136))
                        : _createCommentVNode("", true),
                      _cache[92] || (_cache[92] = _createTextVNode(" Envoyer le RIB "))
                    ], 8, _hoisted_135),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value,
                      title: "POST /ubo/ubo-statement + POST /ubo",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (openSaveFormModal('ubo')))
                    }, [
                      (hipayBusyStep.value === 'ubo')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_138))
                        : _createCommentVNode("", true),
                      _cache[93] || (_cache[93] = _createTextVNode(" Envoyer les UBO "))
                    ], 8, _hoisted_137),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value || isLoadingUboStatement.value,
                      title: "GET /ubo/ubo-statement — lecture seule",
                      onClick: loadRawUboStatement
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-eye", { 'fa-spin fa-spinner': isLoadingUboStatement.value }])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(isLoadingUboStatement.value ? 'Lecture…' : 'Voir le GET UBO'), 1)
                    ], 8, _hoisted_139),
                    (uboRecreateRequired.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "px-5 py-2.5 bg-red-700 text-white rounded-lg hover:bg-red-800 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                          disabled: isBusy.value,
                          title: "Recréation explicite après incohérence entre HiPay et l’historique local",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (openSaveFormModal('ubo_recreate')))
                        }, [
                          (hipayBusyStep.value === 'ubo_recreate')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_141))
                            : _createCommentVNode("", true),
                          _cache[94] || (_cache[94] = _createTextVNode(" Confirmer la recréation UBO "))
                        ], 8, _hoisted_140))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-red-700 text-white rounded-lg hover:bg-red-800 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value,
                      title: "DELETE /ubo/ubo-statement — impossible si WAITING ou UPDATED",
                      onClick: openDeleteUboStatementModal
                    }, [
                      (isDeletingUboStatement.value)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_143))
                        : _createCommentVNode("", true),
                      _cache[95] || (_cache[95] = _createTextVNode(" Supprimer le UBO statement "))
                    ], 8, _hoisted_142),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2",
                      disabled: isBusy.value,
                      title: "Enchaîne identification + bank-info + UBO",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (openSaveFormModal('all')))
                    }, [
                      (hipayBusyStep.value === 'all')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_145))
                        : _createCommentVNode("", true),
                      _cache[96] || (_cache[96] = _createTextVNode(" Tout envoyer à HiPay "))
                    ], 8, _hoisted_144)
                  ]),
                  (rawUboStatement.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("span", null, _toDisplayString(rawUboStatement.value.email), 1),
                          _createElementVNode("span", null, "account_id utilisé : " + _toDisplayString(rawUboStatement.value.accountId), 1)
                        ]),
                        _createElementVNode("pre", _hoisted_148, _toDisplayString(rawUboStatement.value.payload), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ]),
        _createVNode(_unref(ModalComp), {
          "is-visible": showDeleteModal.value,
          title: "Supprimer le bénéficiaire ?",
          content: deleteModalContent.value,
          "cancel-text": "Annuler",
          "confirm-text": "Supprimer",
          onConfirm: confirmDeleteBeneficiary,
          "onUpdate:isVisible": _cache[17] || (_cache[17] = ($event: any) => (showDeleteModal.value = $event))
        }, null, 8, ["is-visible", "content"]),
        _createVNode(_unref(ModalComp), {
          "is-visible": showSaveBeneficiaryModal.value,
          title: "Enregistrer le bénéficiaire",
          content: saveBeneficiaryContent.value,
          "cancel-text": "Annuler",
          "confirm-text": "Enregistrer",
          onConfirm: confirmSaveBeneficiary,
          "onUpdate:isVisible": _cache[18] || (_cache[18] = ($event: any) => (showSaveBeneficiaryModal.value = $event))
        }, null, 8, ["is-visible", "content"]),
        _createVNode(_unref(ModalComp), {
          "is-visible": showSaveFormModal.value,
          title: saveFormModalTitle.value,
          content: saveFormModalContent.value,
          "cancel-text": "Annuler",
          "confirm-text": saveFormModalConfirm.value,
          onConfirm: confirmSaveForm,
          "onUpdate:isVisible": _cache[19] || (_cache[19] = ($event: any) => (showSaveFormModal.value = $event))
        }, null, 8, ["is-visible", "title", "content", "confirm-text"]),
        _createVNode(_unref(ModalComp), {
          "is-visible": showDeleteUboStatementModal.value,
          title: "Supprimer le UBO statement ?",
          content: "Appeler DELETE /ubo/ubo-statement chez HiPay ? Impossible si le statut est WAITING ou UPDATED. Les flags locaux UBO seront réinitialisés.",
          "cancel-text": "Annuler",
          "confirm-text": "Supprimer le statement",
          onConfirm: confirmDeleteUboStatement,
          "onUpdate:isVisible": _cache[20] || (_cache[20] = ($event: any) => (showDeleteUboStatementModal.value = $event))
        }, null, 8, ["is-visible"])
      ], 32)
    ])
  ]))
}
}

})